module.exports = __webpack_public_path__ + "img/fire-flame-09.50917e58.png";